import { useQuery } from '@tanstack/react-query';
import { documentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Folder tree for a job's Documents module. */
export function useDocumentFolders(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.documents.folders(jobId ?? -1),
    queryFn: ({ signal }) =>
      documentApiClient.listFolders(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'document folders' },
  });
}
